import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface IPaginationBarProps {
    onSkipChange: (skip: number) => void;
    skip: number;
    top: number;
    totalCount: number | null;
}

export default function PaginationBar({ onSkipChange, skip, top, totalCount }: IPaginationBarProps) {
    const page = Math.floor(skip / top) + 1;
    const totalPages = totalCount != null ? Math.max(1, Math.ceil(totalCount / top)) : null;
    const hasPrev = skip > 0;
    const hasNext = totalCount != null ? (skip + top) < totalCount : false;

    return (
        <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
            <Button disabled={!hasPrev} onClick={() => onSkipChange(Math.max(0, skip - top))} size="small" variant="outlined">
                Prev
            </Button>
            <Button disabled={!hasNext} onClick={() => onSkipChange(skip + top)} size="small" variant="outlined">
                Next
            </Button>
            <Typography variant="body2">
                {totalPages != null
                    ? `Page ${page} of ${totalPages} · ${totalCount} total`
                    : `Page ${page}`}
            </Typography>
        </Stack>
    );
}
